'use client';

import { Sun, Moon } from 'lucide-react';
import { useTheme } from '@/shared/providers/ThemeProvider';

export function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className='border-border bg-card/80 text-foreground hover:bg-accent fixed top-4 right-4 z-50 flex h-10 w-10 items-center justify-center rounded-full border shadow-lg backdrop-blur-xl transition-all hover:scale-105 hover:shadow-xl'
      aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      {theme === 'dark' ? <Sun className='h-5 w-5' /> : <Moon className='h-5 w-5' />}
    </button>
  );
}
